
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.275 10.182c-.618-.914-1.668-1.396-2.746-1.396-.993 0-1.243.357-2.386.357s-1.393-.357-2.386-.357c-.475 0-.936.107-1.364.289.207.21.403.429.571.675.168.25.307.514.429.786.118-.025.24-.04.364-.04.614 0 1.057.358 2.386.358 1.336 0 1.768-.358 2.386-.358.56 0 1.053.24 1.325.64.189.282.289.61.289.953v1.054h-6.286v1.143c0 .196-.021.385-.057.571h6.629c.789 0 1.428-.64 1.428-1.428v-1.333c0-.71-.214-1.367-.582-1.914zM6.857 1.714A2.288 2.288 0 019.143 4a2.288 2.288 0 01-2.286 2.286A2.288 2.288 0 014.571 4a2.288 2.288 0 012.286-2.286zm0 6.286c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zM12 14.286H1.714v-1.6c0-1.032.657-1.915 1.575-2.254a1.666 1.666 0 011.14 0 7.202 7.202 0 002.428.425 7.25 7.25 0 002.432-.425 1.666 1.666 0 011.14 0 2.404 2.404 0 011.575 2.254v1.6H12zM9.718 8.714c-.425 0-.854.061-1.268.19a5.467 5.467 0 01-3.193-.001 4.398 4.398 0 00-1.268-.189c-1.296 0-2.557.579-3.296 1.675A4.143 4.143 0 000 12.686v1.6C0 15.232.768 16 1.714 16H12c.946 0 1.714-.768 1.714-1.714v-1.6c0-.85-.257-1.64-.7-2.297-.739-1.096-2-1.675-3.296-1.675zm7.425-5.857a1.715 1.715 0 11-.001 3.43 1.715 1.715 0 010-3.43zm0 5.143a3.43 3.43 0 000-6.857 3.43 3.43 0 000 6.857z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    